/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Goal = __webpack_require__(2);
	
	var s3 = window.s3 = window.s3 || {};
	s3.Ecommerce = _Goal.Ecommerce;
	s3.Goal = _Goal.Goal;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = each;
	function each(arr, fn) {
	  if (Array.isArray(arr) || arr instanceof NodeList) {
	    [].forEach.call(arr, fn);
	  } else if ((typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) === 'object') {
	    for (var key in arr) {
	      if (arr.hasOwnProperty(key)) {
	        fn(arr[key], key);
	      }
	    }
	  }
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ecommerce = exports.Goal = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// import matches from '../helpers/matches';
	
	
	var _state = __webpack_require__(10);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _closest = __webpack_require__(4);
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _each = __webpack_require__(1);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _findKey = __webpack_require__(5);
	
	var _findKey2 = _interopRequireDefault(_findKey);
	
	var _values = __webpack_require__(9);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _uniq = __webpack_require__(8);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _clone = __webpack_require__(3);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _pluck = __webpack_require__(7);
	
	var _pluck2 = _interopRequireDefault(_pluck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Goal = exports.Goal = function () {
	  function Goal(params) {
	    _classCallCheck(this, Goal);
	
	    Goal.map = params.map || {};
	    Goal.ecommerce = params.ecommerce || [];
	
	    Ecommerce.init(Goal.ecommerce);
	
	    Goal.bindEvents();
	
	    Goal.observe(function (node) {
	      if (node.tagName !== 'IFRAME') {
	        return;
	      }
	      var contentWindow = node.contentWindow;
	      if (!contentWindow || !contentWindow.addEventListener) {
	        return;
	      }
	      contentWindow.addEventListener('DOMContentLoaded', function () {
	        if (contentWindow.s3 && contentWindow.s3.Goal) {
	          return;
	        }
	        Goal.bindEvents(contentWindow.document);
	      });
	    });
	  }
	
	  // static GOAL_IDS_ATTR = 'data-s3-goal-ids';
	
	
	  _createClass(Goal, null, [{
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	      var events = (0, _pluck2.default)(Goal.map, 'event');
	      (0, _each2.default)(events, function (name) {
	        context.addEventListener(name, function (e) {
	          // e.preventDefault();
	          Goal.handle(e.target, name);
	        }, true);
	      });
	    }
	  }, {
	    key: 'handle',
	    value: function handle(node, eventName) {
	      // пока обрабатываем только submit форм
	      if (node.tagName === 'FORM') {
	        var anketa_id = node.getAttribute(Goal.GOAL_ANKETA_ID_ATTR);
	
	        if (!anketa_id) {
	          var apiFormWrap = (0, _closest2.default)(node, '[' + Goal.GOAL_API_FORM_URL_ATTR + ']');
	          if (apiFormWrap) {
	            anketa_id = Goal.getApiFormId(apiFormWrap);
	          }
	        }
	
	        if (!anketa_id) {
	          return;
	        }
	
	        // сюда обработку апишных форм дописать
	        (0, _each2.default)(Goal.map, function (item) {
	          if (item.object_id == anketa_id && item.event == eventName && (item.code == 'anketa' || item.code == 'anketa2')) {
	            item.object = 'form';
	            Goal.send(item);
	          }
	        });
	        return;
	      }
	
	      // а тут будет все остальное
	    }
	  }, {
	    key: 'send',
	    value: function send(params) {
	      switch (params.system) {
	        case 'analytics':
	          Goal.googleSend(params);
	          break;
	        case 'metrika':
	          Goal.yandexSend(params);
	          break;
	      }
	    }
	  }, {
	    key: 'googleSend',
	    value: function googleSend(params) {
	      var counters = Goal.googleCounters;
	      (0, _each2.default)(counters, function (counter) {
	        // counter('send', 'event', params.object, params.event, params.label);
	        counter(function () {
	          var trackers = counter.getAll();
	          trackers.forEach(function (tracker) {
	            var name = tracker.get('name');
	            counter(name + '.send', 'event', params.object, params.event, params.label);
	          });
	        });
	        if (Goal.logEnabled) {
	          console.info('Goal.send', params);
	        }
	      });
	      return true;
	    }
	  }, {
	    key: 'yandexSend',
	    value: function yandexSend(params) {
	      var counters = Goal.yandexCounters;
	      if (!counters) {
	        return false;
	      }
	      (0, _each2.default)(counters, function (counter) {
	        counter.reachGoal(params.label, { object: params.object, event: params.event });
	        if (Goal.logEnabled) {
	          console.info('Goal.send', params);
	        }
	      });
	      return true;
	    }
	  }, {
	    key: 'observe',
	    value: function observe(fn) {
	      if (!window.MutationObserver) {
	        return;
	      }
	      var observer = new MutationObserver(function (mutations) {
	        mutations.forEach(function (mutation) {
	          [].forEach.call(mutation.addedNodes, function (node) {
	            if (node.nodeType == Node.ELEMENT_NODE) {
	              fn(node);
	            }
	          });
	        });
	      });
	      observer.observe(document, { childList: true, subtree: true });
	    }
	  }, {
	    key: 'getApiFormId',
	    value: function getApiFormId(node) {
	      var url = node.getAttribute(Goal.GOAL_API_FORM_URL_ATTR);
	      if (!url) {
	        return null;
	      }
	      var matches = url.match(/(?:&|\?)param\[form_id\]=(\d+)(?:&|$)/);
	      if (!matches || matches.length !== 2) {
	        return null;
	      }
	      return matches[1];
	    }
	  }, {
	    key: 'googleCounters',
	    get: function get() {
	      if (window.ga) {
	        return [window.ga];
	      }
	      return [];
	    }
	  }, {
	    key: 'yandexCounters',
	    get: function get() {
	      try {
	        return (0, _values2.default)(Ya._metrika.counters);
	      } catch (e) {
	        if (Goal.logEnabled) {
	          console.error(e);
	        }
	        return [];
	      }
	    }
	  }, {
	    key: 'googleDataLayerKeys',
	    get: function get() {
	      if (!window.google_tag_manager) {
	        return [];
	      }
	      var key = (0, _findKey2.default)(google_tag_manager, function (item) {
	        return item.gtmDom && item.gtmLoad;
	      });
	      if (key) {
	        return [key];
	      }
	      return [];
	    }
	  }, {
	    key: 'yandexDataLayerKeys',
	    get: function get() {
	      var counters = Goal.yandexCounters;
	      var keys = [];
	      (0, _each2.default)(counters, function (counter) {
	        if (counter._ecommerce) {
	          keys.push(counter._ecommerce);
	        }
	      });
	      return keys;
	    }
	  }]);
	
	  return Goal;
	}();
	
	Goal.GOAL_ANKETA_ID_ATTR = 'data-s3-anketa-id';
	Goal.GOAL_API_FORM_URL_ATTR = 'data-api-url';
	Goal.logEnabled = false;
	
	var Ecommerce = exports.Ecommerce = function () {
	  function Ecommerce() {
	    _classCallCheck(this, Ecommerce);
	  }
	
	  _createClass(Ecommerce, null, [{
	    key: 'init',
	    value: function init(pool) {
	      pool.forEach(function (item) {
	        var order_id = null;
	        try {
	          order_id = item.ecommerce.purchase.actionField.id;
	        } catch (e) {}
	        if (order_id) {
	          Ecommerce.state.delete('products');
	          var orders = Ecommerce.state.get('orders') || {};
	          if (orders[order_id]) {
	            return;
	          }
	          orders[order_id] = 1;
	          Ecommerce.state.set('orders', orders);
	        }
	        if (item._correction) {
	          Ecommerce.recount(item._correction);
	          // Ecommerce.state.delete('recount');
	          return;
	        }
	        Ecommerce.push(item);
	      });
	
	      setInterval(function () {
	        Ecommerce.send(); // знаю что плохо, но невозможно определить в какой момент на странице появится счетчик (и сколько их всего)
	      }, 100);
	
	      if (!window.jQuery) {
	        return;
	      }
	
	      jQuery.ajaxSetup({
	        beforeSend: function beforeSend(deferred, settings) {
	          var matches = settings.url.match(/(?:\?|&)cmd=(cartAddItem|cartRemoveItem|cartUpdate)(?:&|$)/);
	          if (!matches || matches.length !== 2) {
	            return;
	          }
	          var method = matches[1];
	          switch (method) {
	            case 'cartAddItem':
	              deferred.done(function (json) {
	                if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) == 'object' && json.ecommerce) {
	                  Ecommerce.addProduct(json.ecommerce);
	                }
	              });
	              break;
	            /*case 'cartRemoveItem':
	             case 'cartUpdate':
	             Ecommerce.state.set('recount', true);
	             break;*/
	          }
	        }
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(value) {
	      ['add', 'remove', 'detail', 'purchase'].some(function (action) {
	        if (value.ecommerce[action]) {
	          value.event = 's3_shop_' + action;
	          return true;
	        }
	      });
	      Ecommerce._pool.push({ value: value, layers: {} });
	      Ecommerce.send();
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      var keys = (0, _uniq2.default)(Goal.googleDataLayerKeys.concat(Goal.yandexDataLayerKeys));
	      (0, _each2.default)(keys, function (key) {
	        var layer = window[key] = window[key] || [];
	        (0, _each2.default)(Ecommerce._pool, function (item) {
	          if (!item.layers[key]) {
	            var value = (0, _clone2.default)(item.value);
	            layer.push(value);
	            if (Ecommerce.logEnabled) {
	              console.info('Ecommerce.send', key, value);
	            }
	            item.layers[key] = true;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'addProduct',
	    value: function addProduct(items) {
	      var hash = Ecommerce.state.get('products') || {};
	      items.forEach(function (item) {
	        item.ecommerce.add.products.forEach(function (product) {
	          var key = Ecommerce.getKeyProduct(product);
	          if (!hash[key]) {
	            hash[key] = product;
	            return;
	          }
	          hash[key].quantity += product.quantity;
	        });
	        Ecommerce.push(item);
	      });
	      Ecommerce.state.set('products', hash);
	    }
	  }, {
	    key: 'getKeyProduct',
	    value: function getKeyProduct(product) {
	      return JSON.stringify([product.id + '', product.variant]);
	    }
	  }, {
	    key: 'recount',
	    value: function recount(correction) {
	      var cart = {};
	      (0, _each2.default)(correction, function (item) {
	        cart[Ecommerce.getKeyProduct(item)] = item;
	      });
	
	      var store = Ecommerce.state.get('products') || {};
	
	      (0, _each2.default)(cart, function (item, key) {
	        if (!store[key]) {
	          store[key] = item;
	          Ecommerce.add(item);
	          return;
	        }
	        var diff = cart[key].quantity - store[key].quantity;
	
	        if (diff < 0) {
	          item.quantity = -diff;
	          Ecommerce.remove(item);
	          store[key].quantity += diff;
	        } else if (diff > 0) {
	          item.quantity = diff;
	          Ecommerce.add(item);
	          store[key].quantity += diff;
	        }
	      });
	
	      (0, _each2.default)(store, function (item, key) {
	        if (!cart[key]) {
	          Ecommerce.remove(item);
	          delete store[key];
	        }
	      });
	
	      Ecommerce.state.set('products', store);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(product) {
	      Ecommerce.push({ ecommerce: { remove: { products: [product] } } });
	    }
	  }, {
	    key: 'add',
	    value: function add(product, count) {
	      Ecommerce.push({ ecommerce: { add: { products: [product] } } });
	    }
	  }]);
	
	  return Ecommerce;
	}();
	
	Ecommerce.state = new _state2.default('s3.goal.ecommerce');
	Ecommerce._pool = [];
	Ecommerce.logEnabled = false;
	
	
	if (false) {
	  Goal.logEnabled = true;
	  Ecommerce.logEnabled = true;
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  return JSON.parse(JSON.stringify(obj));
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, selector) {
	  while (node) {
	    if ((0, _matches2.default)(node, selector)) {
	      return node;
	    } else {
	      node = node.parentElement;
	    }
	  }
	  return null;
	};
	
	var _matches = __webpack_require__(6);
	
	var _matches2 = _interopRequireDefault(_matches);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findKey;
	function findKey(obj, fn) {
	  for (var key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      return;
	    }
	    if (fn(obj[key])) {
	      return key;
	    }
	  }
	}

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	var matchesMethodName = exports.matchesMethodName = function () {
	  var list = ['matches', 'matchesSelector', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'];
	  for (var i = 0, len = list.length; i < len; i++) {
	    if (Element.prototype[list[i]]) {
	      return list[i];
	    }
	  }
	  return false;
	}();
	
	function matches(node, selector) {
	  if (!matchesMethodName) {
	    return false;
	  }
	  return node[matchesMethodName](selector);
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (arr, key) {
	  var res = {};
	  (0, _each2.default)(arr, function (item) {
	    var value = item[key];
	    if (value) {
	      res[value] = 1;
	    }
	  });
	  return Object.keys(res);
	};
	
	var _each = __webpack_require__(1);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uniq;
	function uniq(arr) {
	  var res = [];
	  arr.forEach(function (value) {
	    if (res.indexOf(value) === -1) {
	      res.push(value);
	    }
	  });
	  return res;
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = values;
	
	var _each = __webpack_require__(1);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function values(obj) {
	  var arr = [];
	  (0, _each2.default)(obj, function (value) {
	    arr.push(value);
	  });
	  return arr;
	}

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var State = function () {
	  function State(key) {
	    var type = arguments.length <= 1 || arguments[1] === undefined ? 'local' : arguments[1];
	
	    _classCallCheck(this, State);
	
	    this._key = key;
	    this._storage = window[type + 'Storage'];
	    var value = this._storage.getItem(key);
	    this._value = value ? JSON.parse(value) : {};
	  }
	
	  _createClass(State, [{
	    key: '_save',
	    value: function _save() {
	      this._storage.setItem(this._key, JSON.stringify(this._value));
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._value = {};
	      this._save();
	      return this;
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this._value[key];
	    }
	  }, {
	    key: 'set',
	    value: function set(key, value) {
	      this._value[key] = value;
	      this._save();
	      return this;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(key) {
	      delete this._value[key];
	      this._save();
	      return this;
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return _extends({}, this._value);
	    }
	  }, {
	    key: 'isEmpty',
	    get: function get() {
	      return Object.keys(this._value).length === 0;
	    }
	  }]);
	
	  return State;
	}();
	
	exports.default = State;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// s3.goal.js